/* eslint-disable jsx-a11y/no-autofocus */
import React, { FC } from 'react';
import { useTheme } from 'styled-components';

import { useDisclosure, useMedia } from '~src/hooks';

import { Drawer, DrawerCloseButton, DrawerContent } from '../modal';
import { MenuBody } from './menu-body';
import { MenuFooter } from './menu-footer';

type Props = {
  onCloseMenu: () => void;
  isOpenMenu: boolean;
  getContainer?: () => HTMLElement | null;
  noBorder?: boolean;
};

export const Menu: FC<Props> = ({
  onCloseMenu,
  isOpenMenu,
  getContainer,
  noBorder = false,
}) => {
  const { breakpoints } = useTheme();
  const desktop = useMedia(`(max-width: ${breakpoints.desktop}px)`);
  const large = useMedia(`(max-width: ${breakpoints.large}px)`);

  const contact = useDisclosure();

  return (
    <Drawer
      onClose={contact.isOpen ? contact.onClose : onCloseMenu}
      isOpen={isOpenMenu}
      placement="right"
      autoFocus={false}
      size={desktop ? 100 : contact.isOpen ? 65 : large ? 65 : 55}
      getContainer={getContainer}
      scrollBehavior="inside"
      allowPinchZoom
    >
      <DrawerContent>
        <DrawerCloseButton noBorder={noBorder} />
        <MenuBody isOpenContact={contact.isOpen} onCloseMenu={onCloseMenu} />
        <MenuFooter
          onOpenContact={contact.onOpen}
          isOpenContact={contact.isOpen}
        />
      </DrawerContent>
    </Drawer>
  );
};
